import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'sponsors',
    name: 'admin.sponsors',
    component: () => import('@/views/admin/sponsors/List.vue'),
  },
  {
    path: 'sponsors/create',
    name: 'admin.sponsors.create',
    component: () => import('@/views/admin/sponsors/Edit.vue'),
  },
  {
    path: 'sponsors/edit/:id',
    name: 'admin.sponsors.edit',
    component: () => import('@/views/admin/sponsors/Edit.vue'),
  },
  {
    path: 'templates',
    name: 'admin.templates',
    component: () => import('@/views/admin/templates/List.vue'),
  },
  {
    path: 'templates/create',
    name: 'admin.templates.create',
    component: () => import('@/views/admin/templates/Edit.vue'),
  },
  {
    path: 'templates/edit/:id',
    name: 'admin.templates.edit',
    component: () => import('@/views/admin/templates/Edit.vue'),
  },
  {
    path: 'user-groups',
    name: 'admin.user-groups',
    component: () => import('@/views/admin/user-groups/List.vue'),
  },
  {
    path: 'user-groups/create',
    name: 'admin.user-groups.create',
    component: () => import('@/views/admin/user-groups/Edit.vue'),
  },
  {
    path: 'user-groups/edit/:id',
    name: 'admin.user-groups.edit',
    component: () => import('@/views/admin/user-groups/Edit.vue'),
  },
  {
    path: 'users',
    name: 'admin.users',
    component: () => import('@/views/admin/users/List.vue'),
  },
  {
    path: 'users/create',
    name: 'admin.users.create',
    component: () => import('@/views/admin/users/Edit.vue'),
  },
  {
    path: 'users/edit/:id',
    name: 'admin.users.edit',
    component: () => import('@/views/admin/users/Edit.vue'),
  },
  {
    path: 'mails',
    name: 'admin.mails',
    component: () => import('@/views/admin/mails/List.vue'),
  },
  {
    path: 'mails/new',
    name: 'admin.mails.new',
    component: () => import('@/views/admin/mails/TemplateChooser.vue'),
  },
  {
    path: 'mails/create',
    name: 'admin.mails.create',
    component: () => import('@/views/admin/mails/Edit.vue'),
  },
  {
    path: 'mails/edit/:id',
    name: 'admin.mails.edit',
    component: () => import('@/views/admin/mails/Edit.vue'),
  },
  {
    path: 'surveys',
    name: 'admin.surveys',
    component: () => import('@/views/admin/surveys/List.vue'),
  },
  {
    path: 'surveys/create',
    name: 'admin.surveys.create',
    component: () => import('@/views/admin/surveys/Edit.vue'),
  },
  {
    path: 'surveys/edit/:id',
    name: 'admin.surveys.edit',
    component: () => import('@/views/admin/surveys/Edit.vue'),
  },
  {
    path: 'surveys/results/:id',
    name: 'admin.surveys.results',
    component: () => import('@/views/admin/surveys/Results.vue'),
  },
  {
    path: 'reports',
    name: 'admin.reports',
    component: () => import('@/views/admin/reports/Index.vue'),
  },
]

export default routes
